import { SVGFC } from '@repo/toolkit/types'

const OptionIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9864_540543)">
        <path
          d="M12 10.0312V19.875M12 4.125V5.53125M17.625 4.125V13.9688M17.625 18.4688V19.875M6.375 4.125V11.1562M6.375 15.6562V19.875"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.375 15.6562C7.61764 15.6562 8.625 14.6489 8.625 13.4062C8.625 12.1636 7.61764 11.1562 6.375 11.1562C5.13236 11.1562 4.125 12.1636 4.125 13.4062C4.125 14.6489 5.13236 15.6562 6.375 15.6562Z"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 10.0312C13.2426 10.0312 14.25 9.02389 14.25 7.78125C14.25 6.53861 13.2426 5.53125 12 5.53125C10.7574 5.53125 9.75 6.53861 9.75 7.78125C9.75 9.02389 10.7574 10.0312 12 10.0312Z"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.625 18.4688C18.8676 18.4688 19.875 17.4614 19.875 16.2188C19.875 14.9761 18.8676 13.9688 17.625 13.9688C16.3824 13.9688 15.375 14.9761 15.375 16.2188C15.375 17.4614 16.3824 18.4688 17.625 18.4688Z"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9864_540543">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default OptionIcon
